import { ImageTable } from "../../../../../mcleod-ui-common/common/src/imaging/ImageTable";
import { TableComment } from "../../../../general/src/TableComment";
import { TableContact } from "../../../../general/src/TableContact";
import { SegAllocDetailTable } from "../../SegAllocDetailTable";
import { TableDirectDeposit } from "../../TableDirectDeposit";
import { TableLeave } from "../../TableLeave";
import { Office401kRates } from "../Office401kRates";
import { OfficeRecurringPayAdjustmentTable } from "../OfficeRecurringPayAdjustmentTable";
import { Button, Checkbox, CityState, DataHeader, DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOfficePayee extends Layout {
    buttonAdjustLeave: Button;
    buttonClearClassification: Button;
    buttonJobClassification: Button;
    buttonSettlementPayee: Button;
    checkboxDisablePayrollTaxes: Checkbox;
    checkboxExemptFromFed: Checkbox;
    checkboxExemptFromState: Checkbox;
    checkboxMultipleJobs: Checkbox;
    checkboxOffPayeeenableCommissionsPay: Checkbox;
    checkboxOffice: Checkbox;
    checkboxSettlement: Checkbox;
    citystatePayeeCityId: CityState;
    dataheaderOfficePayee: DataHeader;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacerYTD: HorizontalSpacer;
    labelContributions: Label;
    labelDirectDepositStatusMessage: Label;
    labelFederal: Label;
    labelJobClassification: Label;
    labelLastPeriod: Label;
    labelLeaveHistory: Label;
    labelLocalTaxes: Label;
    labelRates: Label;
    labelS: Label;
    labelSettlementHours: Label;
    labelSettlementYTDHours: Label;
    labelSick: Label;
    labelStateTaxes: Label;
    labelTotalHours: Label;
    labelVacation: Label;
    labelVactionTable: Label;
    labelYTDHours: Label;
    labelYTDWages: Label;
    labelYTDWithheld: Label;
    layout401kRates: Office401kRates;
    layoutContact: TableContact;
    layoutDirectDeposit: TableDirectDeposit;
    layoutImageTable: ImageTable;
    layoutRecurringPayAdjustment: OfficeRecurringPayAdjustmentTable;
    layoutSegAllocDetail: SegAllocDetailTable;
    layoutTableComment: TableComment;
    layoutTableLeaveSick: TableLeave;
    layoutTableLeaveVacation: TableLeave;
    panelCheckStubComment: Panel;
    panelContributions: Panel;
    panelDirectDeposit: Panel;
    panelFederalTax: Panel;
    panelFederalTaxFields: Panel;
    panelGeneralOne: Panel;
    panelGeneralThree: Panel;
    panelGeneralTwo: Panel;
    panelJobClassification: Panel;
    panelLeave: Panel;
    panelLeaveHours: Panel;
    panelLeaveTables: Panel;
    panelLocalTax: Panel;
    panelPayToFour: Panel;
    panelPayToMain: Panel;
    panelPayToOne: Panel;
    panelPayToThree: Panel;
    panelPayToTwo: Panel;
    panelRates: Panel;
    panelSettlementHours: Panel;
    panelSettlementStatus: Panel;
    panelSettlementTotalHours: Panel;
    panelSick: Panel;
    panelStateTaxes: Panel;
    panelVacation: Panel;
    panelYTDWages: Panel;
    panelYTDWithheld: Panel;
    payeeCheckCityStateZip: CityState;
    sourceComments: DataSource;
    sourceContacts: DataSource;
    sourceDirectDeposit: DataSource;
    sourceLeaveSick: DataSource;
    sourceLeaveVacation: DataSource;
    sourceOffPayee: DataSource;
    sourceOffRecurDeduct: DataSource;
    sourcePayee401krateHdr: DataSource;
    sourceSegAllocDetail: DataSource;
    switchEFTForIndividual: Switch;
    switchFreezePayables: Switch;
    switchPayeeemailSummary: Switch;
    switchW4Status: Switch;
    switchW9OnFile: Switch;
    tab401kRates: Tab;
    tabAccounting: Tab;
    tabComments: Tab;
    tabCommissions: Tab;
    tabContacts: Tab;
    tabDirectDeposit: Tab;
    tabGeneral: Tab;
    tabImages: Tab;
    tabPayDetails: Tab;
    tabPayTo: Tab;
    tabRecurringPayAdjustments: Tab;
    tabTaxes: Tab;
    tabVacationSickLeave: Tab;
    tabYTD: Tab;
    tabsetOfficePayee: Tabset;
    textboxAddFedToWh: Textbox;
    textboxAddlStToWhold: Textbox;
    textboxChildContract: Textbox;
    textboxCityAmtToWhold: Textbox;
    textboxCityExemptions: Textbox;
    textboxCityTaxCode: Textbox;
    textboxCode: Textbox;
    textboxCountyAmtToWhold: Textbox;
    textboxCountyExemptions: Textbox;
    textboxCountyTaxCode: Textbox;
    textboxCurrency: Textbox;
    textboxDepartment: Textbox;
    textboxDependents: Textbox;
    textboxDrsPayeegrossNonTaxed: Textbox;
    textboxDrsPayeeholidayHoursPd: Textbox;
    textboxDrsPayeeovertimeHoursPd: Textbox;
    textboxDrsPayeeregularHoursPd: Textbox;
    textboxDrsPayeesickHoursPd: Textbox;
    textboxDrsPayeevacationHoursPd: Textbox;
    textboxDrsPayeeytd401kCatchup: Textbox;
    textboxDrsPayeeytd401kContrib: Textbox;
    textboxDrsPayeeytdCityGross: Textbox;
    textboxDrsPayeeytdCityTaxWh: Textbox;
    textboxDrsPayeeytdCountyWages: Textbox;
    textboxDrsPayeeytdCountyWh: Textbox;
    textboxDrsPayeeytdEttWages: Textbox;
    textboxDrsPayeeytdFedGross: Textbox;
    textboxDrsPayeeytdFedWithheld: Textbox;
    textboxDrsPayeeytdFicaHiGros: Textbox;
    textboxDrsPayeeytdFicaHiWh: Textbox;
    textboxDrsPayeeytdFicaOadiGr: Textbox;
    textboxDrsPayeeytdFicaOadiWh: Textbox;
    textboxDrsPayeeytdFuiGross: Textbox;
    textboxDrsPayeeytdHolidayHrs: Textbox;
    textboxDrsPayeeytdOvertimeHrs: Textbox;
    textboxDrsPayeeytdPfmlGross: Textbox;
    textboxDrsPayeeytdPfmlWithheld: Textbox;
    textboxDrsPayeeytdRegHrsPaid: Textbox;
    textboxDrsPayeeytdSdiGross: Textbox;
    textboxDrsPayeeytdSdiWithheld: Textbox;
    textboxDrsPayeeytdSickHrsPaid: Textbox;
    textboxDrsPayeeytdStateGross: Textbox;
    textboxDrsPayeeytdStateWh: Textbox;
    textboxDrsPayeeytdSuiGross: Textbox;
    textboxDrsPayeeytdSuiWithheld: Textbox;
    textboxDrsPayeeytdTotalGross: Textbox;
    textboxDrsPayeeytdVacationHrs: Textbox;
    textboxEfsAccount: Textbox;
    textboxEftFirstName: Textbox;
    textboxEftLastName: Textbox;
    textboxEftMiddleInitial: Textbox;
    textboxExtraWithholdings: Textbox;
    textboxFedAmtToWhold: Textbox;
    textboxFedExemptions: Textbox;
    textboxFedMaritalStatus: Textbox;
    textboxLastRaiseDate: Textbox;
    textboxOffPayeebeginSickDt: Textbox;
    textboxOffPayeebeginVacationDt: Textbox;
    textboxOffPayeecommissionStatus: Textbox;
    textboxOffPayeedivisionId: Textbox;
    textboxOffPayeejobClassCodeId: Textbox;
    textboxOffPayeeovertimeCutoff: Textbox;
    textboxOffPayeeovertimeRate: Textbox;
    textboxOffPayeeregularRate: Textbox;
    textboxOffPayeesickEarned: Textbox;
    textboxOffPayeesickHoursBase: Textbox;
    textboxOffPayeesickHoursDue: Textbox;
    textboxOffPayeesickLastAccrued: Textbox;
    textboxOffPayeeterminalId: Textbox;
    textboxOffPayeevacAccrualRateSick: Textbox;
    textboxOffPayeevacAccrualRateVac: Textbox;
    textboxOffPayeevacLastAccrued: Textbox;
    textboxOffPayeevacationEarned: Textbox;
    textboxOffPayeevacationHoursDue: Textbox;
    textboxOffPayeevacationHrsBase: Textbox;
    textboxOffPayeevacationPayRate: Textbox;
    textboxOffPayeewhenSickAccrues: Textbox;
    textboxOffPayeewhenVacAccrues: Textbox;
    textboxOtherDeductions: Textbox;
    textboxOtherIncome: Textbox;
    textboxParentContract: Textbox;
    textboxPayMethod: Textbox;
    textboxPayeCheckStubComment: Textbox;
    textboxPayeeachBatchClassCode: Textbox;
    textboxPayeeaddress1: Textbox;
    textboxPayeeaddress2: Textbox;
    textboxPayeebirthDate: Textbox;
    textboxPayeecheckAddress2: Textbox;
    textboxPayeecheckAddress: Textbox;
    textboxPayeecheckDate: Textbox;
    textboxPayeecheckName: Textbox;
    textboxPayeecheckNumber: Textbox;
    textboxPayeeemail: Textbox;
    textboxPayeehireDate: Textbox;
    textboxPayeelegalName: Textbox;
    textboxPayeename: Textbox;
    textboxPayeephoneNumber: Textbox;
    textboxPayeepostedCheckDate: Textbox;
    textboxPayeesocialSecurityNo: Textbox;
    textboxPayeeterminationDate: Textbox;
    textboxPaymentFrequency: Textbox;
    textboxPaymentMethod: Textbox;
    textboxPrevCode: Textbox;
    textboxProcessStatus: Textbox;
    textboxStAmtToWhold: Textbox;
    textboxStMaritalStatus: Textbox;
    textboxStateExemptions: Textbox;
    textboxStateTaxCode: Textbox;
    textboxStatus: Textbox;
    textboxSuiTaxCode: Textbox;
    textboxTaxTableCityAux: Textbox;
    textboxTaxTableCityMisc: Textbox;
    textboxTaxTableCountyAux: Textbox;
    textboxTaxTableCountyMisc: Textbox;
    textboxTaxTableFitAux: Textbox;
    textboxTaxTableFitMisc: Textbox;
    textboxTaxTableStAux: Textbox;
    textboxTaxTableStMisc: Textbox;
    textboxTaxTableSuiAux: Textbox;
    textboxTaxTableSuiMisc: Textbox;
    textboxTaxableOwed: Textbox;
    textboxYtdHolidayHrs: Textbox;
    textboxYtdOvertimeHrs: Textbox;
    textboxYtdRegHrsPaid: Textbox;
    textboxYtdSickHrsPaid: Textbox;
    textboxYtdVacationHrs: Textbox;
}
